import { useState } from "react";
import { toast } from "sonner";
import { translate } from "@/i18n";
import { serverUrl } from "@/lib/db";
import { uploadVfsFile } from "@/modules/storage/client-vfs";

const AVATAR_VFS_MOUNT = "images";

export function useAvatar(user: any, onAvatarUpdate: (url: string) => void) {
  const [avatarDialogOpen, setAvatarDialogOpen] = useState(false);
  const [uploadingAvatar, setUploadingAvatar] = useState(false);

  const handleAvatarUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file || !user) return;

    if (!file.type.startsWith('image/')) {
      toast.error(translate('Please select an image file'));
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      toast.error(translate('Image must be less than 5MB'));
      return;
    }

    setUploadingAvatar(true);
    try {
      const ext = (file.name.split(".").pop() || "jpg").toLowerCase().replace(/[^a-z0-9]/g, "") || "jpg";
      const filename = `avatar-${Date.now()}.${ext}`;
      const relativePath = `${user.id}/${filename}`;
      await uploadVfsFile(AVATAR_VFS_MOUNT, relativePath, file);
      const publicUrl = `${serverUrl}/api/vfs/get/${encodeURIComponent(AVATAR_VFS_MOUNT)}/${encodeURIComponent(user.id)}/${encodeURIComponent(filename)}`;
      onAvatarUpdate(publicUrl);
      setAvatarDialogOpen(false);
      toast.success(translate('Avatar updated successfully'));
    } catch (error) {
      console.error('Error uploading avatar:', error);
      toast.error(translate('Failed to upload avatar'));
    } finally {
      setUploadingAvatar(false);
    }
  };

  const handleSelectFromGallery = (imageUrl: string) => {
    onAvatarUpdate(imageUrl);
    setAvatarDialogOpen(false);
    toast.success(translate('Avatar updated successfully'));
  };

  return {
    avatarDialogOpen,
    setAvatarDialogOpen,
    uploadingAvatar,
    handleAvatarUpload,
    handleSelectFromGallery
  };
}
